import moment from 'moment';
import { crRoles } from '../../../../constants';

export const getPriceValue = (data, costing_year) => {
  const currentYear = costing_year ? moment(costing_year).year() : moment().year();

  // Check if planned_price_1 and planned_price_date_1 are present and in the current year
  if (
    data.planned_price_1 &&
    parseFloat(data.planned_price_1) > 0 &&
    data.planned_price_date_1 &&
    moment(data.planned_price_date_1).year() === currentYear
  ) {
    return parseFloat(data.planned_price_1);
  }

  // Check if standard_price and last_change_price are present and in the current year
  if (
    data.standard_price &&
    parseFloat(data.standard_price) > 0 &&
    data.last_change_price &&
    moment(data.last_change_price).year() === currentYear
  ) {
    return parseFloat(data.standard_price);
  }

  // Default to 0 if neither condition is met
  return 0;
};
// helper function to transform each item
export function transformItem(item, costing_year, crAssignedSpocs) {
  const material = item.IntCrSKUPlantBOM || {};

  const stepNames =
    item?.GeneralDetails?.checkstepstatus
      ?.flatMap((step) => step.IntCrSteps?.map((intCrStep) => intCrStep.name))
      .join(', ') || 'N/A';

  const price = getPriceValue(material, costing_year);

  return {
    id: item.id,
    mat_group_desc: item.material_group_description,
    manual_closed: item.manual_closed || false,
    component_id: item.component_id,
    sku_number: item.int_cr_sku_selector?.sku,
    sku_description: item.int_cr_sku_selector?.sku_description,
    material_number: material.component,
    material_description: material.component_description,
    material_status: material.plant_specific_status,
    price_updated: material.price_submitted_on
      ? moment(material.price_submitted_on).format('DD/MM/YYYY')
      : 'N/A',
    not_procurement_material: material.not_procurement_material,
    urgency: item?.int_cr_record?.urgency || 'N/A',
    producing_plant: item.int_cr_producing_plant?.producing_plant,
    base_unit: material.price_unit,
    uom: material.uom,
    currency: material.currency,
    cost_value: price,

    fpna_analyst_responsible: crAssignedSpocs(item.int_cr_producing_plant?.producing_plant),
    fpna_analyst_responsible_id: item?.costing_ticket_assigned?.id || null,
    asm: material.asm,
    costing_request_id: item.costing_request_id,
    start_date: item.start_date,
    procurement_spoc: crAssignedSpocs(
      item.int_cr_producing_plant?.producing_plant,
      crRoles.procurement,
    ),
    procurement_spoc_id: item?.step_assigned?.id || null,
    mother_costing_request_id: item?.GeneralDetails?.costing_request_id || 'N/A',
    mother_costing_request_created_on: item?.GeneralDetails
      ? moment(item?.GeneralDetails?.costing_request_id?.createdAt).format('DD/MM/YYYY')
      : 'N/A',
    pack_mat_price_requesting_date: item.start_date
      ? moment(item.start_date).format('DD/MM/YYYY')
      : 'N/A',
    pack_mat_price_requesting_date_plain: item.start_date,
    monther_cr_status: item?.GeneralDetails?.IntCrStatus?.status || 'N/A',
    step_names: stepNames,
    comment: material.comment,
    production_plant: item?.int_cr_producing_plant?.producing_plant,
    planned_price_date_1: material.planned_price_date_1,
    status: item.status,
    material_type: material.Material_type,
  };
}
